import { getSigners } from 'lib/api/business';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import Table, { Header } from 'lib/designSystem/Table';
import { showAlert } from 'lib/functions/utils';
import { User } from 'lib/types/models';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import AssignSigner from './Components/AssignSigner';
import CreateSigner from './Components/CreateSigner';

const Signers = () => {
  const { id: businessIdentifier } = useParams();
  const dispatch = useDispatch();
  const [signers, setSigners] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [openCreateSigner, setOpenCreateSigner] = useState(false);
  const [openAssignSigner, setOpenAssignSigner] = useState(false);
  const tableHeaders: Header[] = [
    { key: 'identifier', label: 'Rut' },
    { key: 'name', label: 'Nombre' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Teléfono' },
  ];

  const fetchSigners = async () => {
    try {
      if (!businessIdentifier)
        return showAlert(
          dispatch,
          'error',
          'Problema al obtener los firmantes',
        );
      const signersResponse = await getSigners(dispatch, businessIdentifier);
      setSigners(signersResponse);
    } catch (error) {
      console.error('Error fetching signers:', error);
    } finally {
      setLoading(false);
    }
  };

  const buttons: CustomButtonProps[] = [
    {
      action: () => setOpenAssignSigner(true),
      name: 'Asignar firmante',
      color: 'secondary',
    },
    {
      action: () => setOpenCreateSigner(true),
      name: 'Agregar firmante',
      color: 'primary',
    },
  ];

  useEffect(() => {
    void fetchSigners();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <>
      <HeaderWithActions
        title="Lista con los firmantes de la empresa."
        buttons={buttons}
        variant="body1"
      />
      <Table data={signers} dataHeaders={tableHeaders} />
      <CreateSigner
        open={openCreateSigner}
        setOpen={setOpenCreateSigner}
        fetchSigners={fetchSigners}
        businessIdentifier={businessIdentifier}
      />
      <AssignSigner
        open={openAssignSigner}
        setOpen={setOpenAssignSigner}
        fetchSigners={fetchSigners}
        businessIdentifier={businessIdentifier}
      />
    </>
  );
};

export default Signers;
